module.exports = __webpack_public_path__ + "media/images/piggy-59d27f52.png";